import { lambda } from '../../amplify'
import { moment } from '../../plugins'
import store from '@/store'
import router from '@/router'

const state = {
    pools: [],
    poolId: '',
    labResults: [],
    statusColors: {},
    poolIndexes: {},
    history: []
}

// getters
const getters = {
    poolIndex: state => state.poolIndexes ? state.poolIndexes[state.poolId] : null,
    poolId: state => state.poolId,
    pool: state => Object.keys(state.poolIndexes).length && state.poolId ? state.pools[state.poolIndexes[state.poolId]] : null,
    pools: state => state.pools,
    senseOnly: state => {
        return Object.keys(state.poolIndexes).length && state.poolId && state.pools[state.poolIndexes[state.poolId]] && state.pools[state.poolIndexes[state.poolId]].pods
            ? state.pools[state.poolIndexes[state.poolId]].pods[0].pod.senseOnly : false
    },
    podInstalled: state => {
        const pool = Object.keys(state.poolIndexes).length && state.poolId ? state.pools[state.poolIndexes[state.poolId]] : null
        return Boolean(pool && pool.pods && pool.pods.length)
    },

    labResult: state => Object.keys(state.poolIndexes).length && state.poolId ? state.labResults[state.poolIndexes[state.poolId]] : null,
    labResults: state => state.labResults,

    statusColors: state => state.statusColors,
    history: state => state.history
}

// actions
const actions = {
    getPools ({ commit, state, dispatch }, username = false) {
        const userId = username || store.getters['auth/user'].username
        lambda('getDashboardView', {
            userId,
            returnPreCfg: true
        }).then(data => {
            commit('setPools', data.waterBodies)
            commit('setPoolIndexes', data.waterBodyIdToIndex)
            commit('setStatusColors', data.statusColors)
            dispatch('getHistory')
            if (!state.poolId) {
                if (data.waterBodies && data.waterBodies.length) {
                    router.push({ name: 'Mypools', params: { id: data.waterBodies[0].waterBodyId } }).catch(e => e)
                } else {
                    router.push({ name: 'MypoolsCreate' }).catch(e => e)
                }
            }
        }).catch(err => {
            throw err
        })
    },

    getLabResults ({ commit }, username = false) {
        const userId = username || store.getters['auth/user'].username
        lambda('getLabView', {
            userId
        }).then(data => {
            commit('setLabResults', data.waterBodies)
        }).catch(err => {
            throw err
        })
    },

    getHistory ({ commit, state }) {
        const podIds = state.pools.map(item => item.pods && item.pods[0] && item.pods[0].podId ? item.pods[0].podId : false)
            .filter(item => item)

        if (!podIds.length) return
        lambda('managePod', {
            queryDataHistoryReq: {
                podIds,
                maxResults: 200,
                startTime: moment().subtract(1, 'w').toISOString(),
                endTime: moment().toISOString(),
                returnCsv: false
            }
        }).then(data => {
            if (data.code === 'OK') commit('setHistory', data.queryDataHistoryRsp.data)
        }).catch(err => {
            throw err
        })
    },

    setPoolId ({ commit, state }, id) {
        commit('setPoolId', id)
    },

    emptyState ({ commit }) {
        commit('setPoolId', null)
        commit('setPools', null)
        commit('setLabResults', null)
        commit('setStatusColors', null)
        commit('setPoolIndexes', null)
        commit('setHistory', null)
    }
}

// mutations
const mutations = {
    setPoolId (state, poolId) {
        state.poolId = poolId || ''
    },
    setPools (state, pools) {
        state.pools = pools || []
    },
    setLabResults (state, labResults) {
        state.labResults = labResults || []
    },
    setStatusColors (state, statusColors) {
        state.statusColors = statusColors || {}
    },
    setPoolIndexes (state, poolIndexes) {
        state.poolIndexes = poolIndexes || {}
    },
    setHistory (state, history) {
        state.history = history || []
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
